module.exports = __webpack_public_path__ + "static/media/recommends_05_smarter_decision.e08b566f.png";